import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronLeft} from "@fortawesome/free-solid-svg-icons";

export default class SideBar extends React.Component {

    render() {

        const {handleChangeCollapse, handleChangePage, collapse, currentPage} = this.props;

        return (
            <>
                <div className={'border-line pink'}/>

                <div className={'px-3 py-4 bg-white rounded-10 border-top-rounded-none'}>

                    <p>iLEAD Tools is a unique personal development and self-coaching resource from Pearn Kandola
                        business psychologists. It distils 30 years of consultancy and training experience gained in
                        private and public organisations, across the UK and internationally, into 47 tools grouped in 3
                        volumes of clear, concise, expert leadership advice.</p>

                    <div className={'ilead-tools-sidebar-body'}>
                        <div className={'ilead-tools-collapse'}>
                            <h4 onClick={handleChangePage('People')}>PEOPLE</h4>

                            <span className={'collapse-icon'} onClick={handleChangeCollapse('people')}>
                                <FontAwesomeIcon icon={collapse.people ? faChevronDown : faChevronLeft} />
                            </span>
                        </div>

                        <div className={collapse.people ? 'd-block' : 'd-none'}>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Mobilising</p>
                            <ul>
                                <li onClick={handleChangePage('HowToMotivateOthers')}
                                    className={currentPage === 'HowToMotivateOthers' ? 'active' : ''}>
                                    How to motivate others
                                </li>
                                <li onClick={handleChangePage('HowToRaiseEnergyLevels')}
                                    className={currentPage === 'HowToRaiseEnergyLevels' ? 'active' : ''}>
                                    How to raise energy levels
                                </li>
                                <li onClick={handleChangePage('HowToBeAssertive')}
                                    className={currentPage === 'HowToBeAssertive' ? 'active' : ''}>
                                    How to be assertive
                                </li>
                                <li onClick={handleChangePage('HowToInfluenceOthers')}
                                    className={currentPage === 'HowToInfluenceOthers' ? 'active' : ''}>
                                    How to influence others
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Connecting</p>
                            <ul>
                                <li onClick={handleChangePage('HowToDevelopRapport')}
                                    className={currentPage === 'HowToDevelopRapport' ? 'active' : ''}>
                                    How to develop rapport
                                </li>
                                <li onClick={handleChangePage('HowToCommunicateEffectively')}
                                    className={currentPage === 'HowToCommunicateEffectively' ? 'active' : ''}>
                                    How to communicate effectively
                                </li>
                                <li onClick={handleChangePage('HowToActivelyListen')}
                                    className={currentPage === 'HowToActivelyListen' ? 'active' : ''}>
                                    How to actively listen
                                </li>
                                <li onClick={handleChangePage('HowToManageYourImpact')}
                                    className={currentPage === 'HowToManageYourImpact' ? 'active' : ''}>
                                    How to manage your impact
                                </li>
                                <li onClick={handleChangePage('HowToManageDifficultConversations')}
                                    className={currentPage === 'HowToManageDifficultConversations' ? 'active' : ''}>
                                    How to manage difficult conversations
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Building</p>
                            <ul>
                                <li onClick={handleChangePage('HowToCreateTeamIdentity')}
                                    className={currentPage === 'HowToCreateTeamIdentity' ? 'active' : ''}>
                                    How to create team identity
                                </li>
                                <li onClick={handleChangePage('HowToBuildAndMaintainTrust')}
                                    className={currentPage === 'HowToBuildAndMaintainTrust' ? 'active' : ''}>
                                    How to build and maintain trust
                                </li>
                                <li onClick={handleChangePage('HowToGainBuyInAndCommitment')}
                                    className={currentPage === 'HowToGainBuyInAndCommitment' ? 'active' : ''}>
                                    How to gain buy-in and commitment
                                </li>
                                <li onClick={handleChangePage('HowToSupportAndChallengeInTandem')}
                                    className={currentPage === 'HowToSupportAndChallengeInTandem' ? 'active' : ''}>
                                    How to support and challenge in tandem
                                </li>
                                <li onClick={handleChangePage('HowToGiveFeedback')}
                                    className={currentPage === 'HowToGiveFeedback' ? 'active' : ''}>
                                    How to give feedback
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Meaning</p>
                            <ul>
                                <li onClick={handleChangePage('HowToIdentifyYourPersonalMeaning')}
                                    className={currentPage === 'HowToIdentifyYourPersonalMeaning' ? 'active' : ''}>
                                    How to identify your personal meaning
                                </li>
                                <li onClick={handleChangePage('HowToBeAnEffectiveRoleModel')}
                                    className={currentPage === 'HowToBeAnEffectiveRoleModel' ? 'active' : ''}>
                                    How to be an effective role model
                                </li>
                                <li onClick={handleChangePage('HowToIdentifyPersonalLearningStyles')}
                                    className={currentPage === 'HowToIdentifyPersonalLearningStyles' ? 'active' : ''}>
                                    How to identify personal learning styles
                                </li>
                                <li onClick={handleChangePage('HowToDevelopOthers')}
                                    className={currentPage === 'HowToDevelopOthers' ? 'active' : ''}>
                                    How to develop others
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className={'ilead-tools-sidebar-body'}>
                        <div className={'ilead-tools-collapse'}>
                            <h4 onClick={handleChangePage('Thought')}>THOUGHT</h4>

                            <span className={'collapse-icon'} onClick={ handleChangeCollapse('thought')}>
                                <FontAwesomeIcon icon={collapse.thought ? faChevronDown : faChevronLeft} />
                            </span>
                        </div>

                        <div className={collapse.thought ? 'd-block' : 'd-none'}>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Imagining</p>
                            <ul>
                                <li onClick={handleChangePage('HowToDevelopStrategicLongTermGoals')}
                                    className={currentPage === 'HowToDevelopStrategicLongTermGoals' ? 'active' : ''}>
                                    How to develop strategic long-term goals
                                </li>
                                <li onClick={handleChangePage('HowToBeInnovative')}
                                    className={currentPage === 'HowToBeInnovative' ? 'active' : ''}>
                                    How to be innovative
                                </li>
                                <li onClick={handleChangePage('HowToThinkAboutProblemsLaterally')}
                                    className={currentPage === 'HowToThinkAboutProblemsLaterally' ? 'active' : ''}>
                                    How to think about problems laterally
                                </li>
                                <li onClick={handleChangePage('HowToReframeProblems')}
                                    className={currentPage === 'HowToReframeProblems' ? 'active' : ''}>
                                    How to reframe problems
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Discerning</p>
                            <ul>
                                <li onClick={handleChangePage('HowToPrioritiseTasksReadyForAction')}
                                    className={currentPage === 'HowToPrioritiseTasksReadyForAction' ? 'active' : ''}>
                                    How to prioritise tasks ready for action
                                </li>
                                <li onClick={handleChangePage('HowToMakeTimelyDecisions')}
                                    className={currentPage === 'HowToMakeTimelyDecisions' ? 'active' : ''}>
                                    How to make timely decisions
                                </li>
                                <li onClick={handleChangePage('HowToFocusOnTheBiggerPicture')}
                                    className={currentPage === 'HowToFocusOnTheBiggerPicture' ? 'active' : ''}>
                                    How to focus on the bigger picture
                                </li>
                                <li onClick={handleChangePage('HowToMakeComplexIdeasSimpleClearAndConcise')}
                                    className={currentPage === 'HowToMakeComplexIdeasSimpleClearAndConcise' ? 'active' : ''}>
                                    How to make complex ideas simple, clear and concise
                                </li>
                                <li onClick={handleChangePage('HowToMakeEthicalDecisions')}
                                    className={currentPage === 'HowToMakeEthicalDecisions' ? 'active' : ''}>
                                    How to make ethical decisions
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Shaping</p>
                            <ul>
                                <li onClick={handleChangePage('HowToMakeReasonedJudgements')}
                                    className={currentPage === 'HowToMakeReasonedJudgements' ? 'active' : ''}>
                                    How to make reasoned judgements
                                </li>
                                <li onClick={handleChangePage('HowToDirectPeople')}
                                    className={currentPage === 'HowToDirectPeople' ? 'active' : ''}>
                                    How to direct people
                                </li>
                                <li onClick={handleChangePage('HowToImproveProcesses')}
                                    className={currentPage === 'HowToImproveProcesses' ? 'active' : ''}>
                                    How to improve processes
                                </li>
                                <li onClick={handleChangePage('HowToBeConfidentInYourJudgementCalls')}
                                    className={currentPage === 'HowToBeConfidentInYourJudgementCalls' ? 'active' : ''}>
                                    How to be confident in your judgement calls
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Challenging</p>
                            <ul>
                                <li onClick={handleChangePage('HowToChallengeOthersEffectively')}
                                    className={currentPage === 'HowToChallengeOthersEffectively' ? 'active' : ''}>
                                    How to challenge others effectively
                                </li>
                                <li onClick={handleChangePage('HowToBalanceRiskWithPotentialBenefits')}
                                    className={currentPage === 'HowToBalanceRiskWithPotentialBenefits' ? 'active' : ''}>
                                    How to balance risk with potential benefits
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className={'ilead-tools-sidebar-body'}>
                        <div className={'ilead-tools-collapse'}>
                            <h4 onClick={handleChangePage('Task')}>TASK</h4>

                            <span className={'collapse-icon'} onClick={handleChangeCollapse('task')}>
                                <FontAwesomeIcon icon={collapse.task ? faChevronDown : faChevronLeft} />
                            </span>
                        </div>

                        <div className={collapse.task ? 'd-block' : 'd-none'}>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Owning</p>
                            <ul>
                                <li onClick={handleChangePage('HowToTakeResponsibility')}
                                    className={currentPage === 'HowToTakeResponsibility' ? 'active' : ''}>
                                    How to take responsibility
                                </li>
                                <li onClick={handleChangePage('HowToDeliverEveryTime')}
                                    className={currentPage === 'HowToDeliverEveryTime' ? 'active' : ''}>
                                    How to deliver every time
                                </li>
                                <li onClick={handleChangePage('HowToTakeControl')}
                                    className={currentPage === 'HowToTakeControl' ? 'active' : ''}>
                                    How to take control
                                </li>
                                <li onClick={handleChangePage('HowToKnowWhenAndHowToTakeRisks')}
                                    className={currentPage === 'HowToKnowWhenAndHowToTakeRisks' ? 'active' : ''}>
                                    How to know when and how to take risks
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Driving</p>
                            <ul>
                                <li onClick={handleChangePage('HowToMaintainMomentum')}
                                    className={currentPage === 'HowToMaintainMomentum' ? 'active' : ''}>
                                    How to maintain momentum
                                </li>
                                <li onClick={handleChangePage('HowToCopeWithSetbacks')}
                                    className={currentPage === 'HowToCopeWithSetbacks' ? 'active' : ''}>
                                    How to cope with setbacks
                                </li>
                                <li onClick={handleChangePage('HowToFormulateActionPlans')}
                                    className={currentPage === 'HowToFormulateActionPlans' ? 'active' : ''}>
                                    How to formulate action plans
                                </li>
                                <li onClick={handleChangePage('HowToWinAndManageResources')}
                                    className={currentPage === 'HowToWinAndManageResources' ? 'active' : ''}>
                                    How to win and manage resources
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Engaging</p>
                            <ul>
                                <li onClick={handleChangePage('HowToCommunicateYourVision')}
                                    className={currentPage === 'HowToCommunicateYourVision' ? 'active' : ''}>
                                    How to communicate your vision
                                </li>
                                <li onClick={handleChangePage('HowToDelegate')}
                                    className={currentPage === 'HowToDelegate' ? 'active' : ''}>
                                    How to delegate
                                </li>
                                <li onClick={handleChangePage('HowToEngageOthersToDeliver')}
                                    className={currentPage === 'HowToEngageOthersToDeliver' ? 'active' : ''}>
                                    How to engage others to deliver
                                </li>
                            </ul>

                            <p className={'font-weight-bold font-size-16 mb-0'}>Sustaining</p>
                            <ul>
                                <li onClick={handleChangePage('HowToBuildResilience')}
                                    className={currentPage === 'HowToBuildResilience' ? 'active' : ''}>
                                    How to build resilience
                                </li>
                                <li onClick={handleChangePage('HowToUseOptimismToAchieve')}
                                    className={currentPage === 'HowToUseOptimismToAchieve' ? 'active' : ''}>
                                    How to use optimism to achieve
                                </li>
                                <li onClick={handleChangePage('HowToGetTheMostOutOfYourself')}
                                    className={currentPage === 'HowToGetTheMostOutOfYourself' ? 'active' : ''}>
                                    How to get the most out of yourself
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};